document.addEventListener("DOMContentLoaded", () => {

    const enamelLayer = document.getElementById("enamelLayer");
    const stoneLayer = document.getElementById("stoneLayer");

    if (!enamelLayer || !stoneLayer) return;

    /* -------------------------
       NAME MAPS (slug -> Shopify's exact wording)
    --------------------------*/

    const enamelNames = {
        navy: "Midnight Blue",
        olive: "Olive Green",
        cherry: "Cherry Red",
        darkgreen: "Dark Green",
        paleskyblue: "Pale Sky Blue",
        lightpink: "Light Pink"
    };

    const stoneNames = {
        emerald: "Emerald",
        ruby: "Ruby",
        sapphire: "Sapphire",
        aqua: "Aqua",
        lightpink: "Light Pink"
    };

    const finishImages = {
        Gold: "https://cdn.shopify.com/s/files/1/0640/6520/8570/files/Exclusive_heart_charm.png?v=1784043628",
        Silver: "https://cdn.shopify.com/s/files/1/0640/6520/8570/files/silver_heart.png?v=1784043628"
    };

    /* -------------------------
       IMAGES (only add entries you actually have PNGs for)
    --------------------------*/

    const enamelImages = {
        navy: "https://cdn.shopify.com/s/files/1/0640/6520/8570/files/navy_blue_heart.png?v=1784043628",
        olive: "https://cdn.shopify.com/s/files/1/0640/6520/8570/files/Olive_green_Heart_enamel.png?v=1784043628"
        // cherry, darkgreen, paleskyblue, lightpink: add later
    };

    const stoneImages = {
        emerald: "https://cdn.shopify.com/s/files/1/0640/6520/8570/files/emerald_gemstone_heart.png?v=1784043627",
        ruby: "https://cdn.shopify.com/s/files/1/0640/6520/8570/files/Ruby_pink_gemstone.png?v=1784043628"
        // sapphire, aqua, lightpink: add later
    };

    /* -------------------------
       VARIANT DATA (from Liquid)
    --------------------------*/

    const variantDataEl = document.getElementById("stackBuilderVariantData");
    const optionNamesEl = document.getElementById("stackBuilderOptionNames");

    if (!variantDataEl || !optionNamesEl) return;

    const variants = JSON.parse(variantDataEl.textContent);
    const optionNames = JSON.parse(optionNamesEl.textContent);

    const idInput = document.getElementById("stackBuilderVariantId");
    const atcButton = document.querySelector("#stackBuilderForm .add-to-cart");
    const priceEl = document.getElementById("stackBuilderPrice");

    /* -------------------------
       SELECTION STATE
    --------------------------*/

    let selectedEnamel = "navy";
    let selectedStone = "emerald";

    const selections = {}; // { "Finish": "Gold", "Size": "US 5/ IND 9" }

    // Pre-fill Finish/Size from whichever button has data-active="true"
    document.querySelectorAll(".js-builder-option[data-active='true']").forEach(btn => {
        selections[btn.dataset.optionName] = btn.dataset.value;
    });

    /* -------------------------
       MATCHING LOGIC
    --------------------------*/

    function getColourValue() {
        return `${enamelNames[selectedEnamel]} Enamel + ${stoneNames[selectedStone]} Heart`;
    }

    function findMatchingVariant() {

        const target = { ...selections, Colour: getColourValue() };

        return variants.find(v => {
            return optionNames.every((name, i) => {
                const key = "option" + (i + 1);
                return target[name] && v[key] === target[name];
            });
        });
    }

    function formatMoney(cents) {
        return "₹" + (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 });
    }

    function updateSelectedVariant() {

        const variant = findMatchingVariant();

        if (variant) {
            idInput.value = variant.id;
            atcButton.disabled = !variant.available;
            atcButton.textContent = variant.available ? "Add to cart" : "Sold out";
            if (priceEl) priceEl.textContent = formatMoney(variant.price);
        } else {
            atcButton.disabled = true;
            atcButton.textContent = "This combination isn't available";
        }
    }

    /* -------------------------
       ENAMEL SWATCHES
    --------------------------*/

    document.querySelectorAll("[data-enamel]").forEach(button => {

        button.addEventListener("click", () => {

            selectedEnamel = button.dataset.enamel;

            if (enamelImages[selectedEnamel]) {
                enamelLayer.src = enamelImages[selectedEnamel];
                enamelLayer.style.display = "block";
            }

            document.querySelectorAll("[data-enamel]").forEach(b => b.classList.remove("active"));
            button.classList.add("active");

            const enamelValueEl = document.getElementById("enamelColourValue");
            if (enamelValueEl) enamelValueEl.textContent = enamelNames[selectedEnamel];

            updateSelectedVariant();
        });

    });

    /* -------------------------
       STONE SWATCHES
    --------------------------*/

    document.querySelectorAll("[data-stone]").forEach(button => {

        button.addEventListener("click", () => {

            selectedStone = button.dataset.stone;

            if (stoneImages[selectedStone]) {
                stoneLayer.src = stoneImages[selectedStone];
                stoneLayer.style.display = "block";
            }

            document.querySelectorAll("[data-stone]").forEach(b => b.classList.remove("active"));
            button.classList.add("active");

            const stoneValueEl = document.getElementById("stoneColourValue");
            if (stoneValueEl) stoneValueEl.textContent = stoneNames[selectedStone];

            updateSelectedVariant();
        });

    });

    /* -------------------------
       FINISH SWATCHES (and any other non-Size options)
    --------------------------*/

    document.querySelectorAll(".js-builder-option").forEach(button => {

        button.addEventListener("click", () => {

            const name = button.dataset.optionName;
            const value = button.dataset.value;

            selections[name] = value;

            if (name === "Finish" && baseLayer && finishImages[value]) {
                baseLayer.src = finishImages[value];
            }

            document
                .querySelectorAll(`.js-builder-option[data-option-name="${name}"]`)
                .forEach(b => b.classList.remove("active"));
            button.classList.add("active");

            const labelEl = document.querySelector(`.builder-label__value[data-label-for="${name}"]`);
            if (labelEl) labelEl.textContent = value;

            updateSelectedVariant();
        });

    });

    /* -------------------------
       SIZE DROPDOWN
    --------------------------*/

    document.querySelectorAll(".js-builder-select").forEach(select => {

        const name = select.dataset.optionName;

        // set initial selection from the first option
        selections[name] = select.value;

        select.addEventListener("change", () => {
            selections[name] = select.value;
            updateSelectedVariant();
        });

    });

    /* -------------------------
       QUANTITY BUTTONS
    --------------------------*/

    const quantityInput = document.getElementById("stackBuilderQty");

    if (quantityInput) {
        document.querySelectorAll("quantity-wrapper [data-quantity]").forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                let value = parseInt(quantityInput.value, 10) || 1;
                if (button.dataset.quantity === "up") value += 1;
                else if (value > 1) value -= 1;
                quantityInput.value = value;
            });
        });
    }

    /* -------------------------
       INIT
    --------------------------*/

    // Reflect initial Finish/Size active state in the labels
    document.querySelectorAll(".js-builder-option[data-active='true']").forEach(btn => {
        const labelEl = document.querySelector(`.builder-label__value[data-label-for="${btn.dataset.optionName}"]`);
        if (labelEl) labelEl.textContent = btn.dataset.value;
    });

    updateSelectedVariant();

});